import styled from 'styled-components';

export const ErrorMessage = styled.span`
    font-size: 12px;
    color: #e74c3c;
    display: inline-block;
    margin-top: 3px;
    max-width: 250px;
`;